<!DOCTYPE html>
<html lang="en">
<head>
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous">
    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js" integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM" crossorigin="anonymous"></script>
    <meta charset="UTF-8">
    <!-- <meta name="viewport" content="width=device-width, initial-scale=1.0"> -->
    <title>SOFIA</title>
</head>
<body>
  <main>
    <div>
      <!-- <app-header [defaultLanguage]="defaultLanguage" [federaleURL]="federaleURL"></app-header> -->
      <router-outlet></router-outlet>
      <!-- <app-footer></app-footer>       -->
    </div>
    
    <!-- <div >
      <div class="display-center">
      <app-header [defaultLanguage]="defaultLanguage" [federaleURL]="federaleURL"></app-header>
      <router-outlet></router-outlet>
      <app-footer></app-footer>  
    </div>    
    </div>

    <ng-template>
      <app-header [defaultLanguage]="defaultLanguage" [federaleURL]="federaleURL"></app-header>
      <router-outlet></router-outlet>
      <app-footer></app-footer>      
    </ng-template> -->
    

  </main>
</body>
</html>
